<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <KeyValuesForm @submit-requested="submitRequested"></KeyValuesForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import KeyValuesForm from './KeyValuesForm.vue'

  export default {
  components: { KeyValuesForm },
  methods: {
    ...mapActions('keyValues', ['postKeyValue']),
    submitRequested (input) {
      this.postKeyValue(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 